/**
 * Generates a unique string id of length provided
 * @param {number} length - 1-13
 * @default 5
 * @return {string} - the string id
 */
export function generateID(length = 5) {
  return Math.random().toString(36).substr(2, length)
}
